import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbToastrService, NbGlobalPhysicalPosition, NbAccordionItemBodyComponent } from '@nebular/theme';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EHSService } from '../ehs-micro-indicador.service';
import { InternalSearchService } from '../../internal-search/internal-search.service';
import { validateHorizontalPosition } from '@angular/cdk/overlay';

@Component({
  selector: 'ngx-show-ehs-micro-indicador',
  templateUrl: 'show-ehs-micro-indicador.component.html',
  styleUrls: ['show-ehs-micro-indicador.component.scss'],
})
export class ShowEHSMicroIndicadorComponent implements OnInit {

  public ehsMicroIndicador: any = {};
  public parentId = '';

  registerForm: FormGroup;
  submitted = false;
  entities;
  periodos;
  entitySelected: any = {};
  periodoSelected: any = {};

  searchs;
  searchSelected;
  dropdownSettings = {};
  dropdownSettingsSearch = {};

  constructor(private ehsService: EHSService, private route: ActivatedRoute,
    private toastrService: NbToastrService, private router: Router, private formBuilder: FormBuilder,
    private internalSearchService: InternalSearchService) {
    this.parentId = this.route.snapshot.params.parentId;

    this.entities = [
      { name: 'Feedback', code: 'FEEDBACK' },
      { name: 'Pesquisa interna', code: 'INTERNAL_SEARCH' },
      { name: 'Externa', code: 'EXTERNAL' }
    ];
    this.periodos = [
      { name: 'Diario', code: 'DIARY' },
      { name: 'Semanal', code: 'WEEKLY' },
      { name: 'Mensal', code: 'MONTHLY' },
      { name: 'Trimestral', code: 'QUARTERLY' },
      { name: 'Semestral', code: 'SEMIANNUAL' },
      { name: 'Anual', code: 'YEARLY' },
    ];

    this.dropdownSettings = {
      idField: 'code',
      textField: 'name',
      singleSelection: true,
      selectAllText: 'Selecionar tudo',
      searchPlaceholderText: 'Localizar',
      unSelectAllText: 'Deselecionar Tudo',
      allowSearchFilter: true,
      noDataAvailablePlaceholderText: 'Nenhum registro encontrado',
    };

    this.dropdownSettingsSearch = {
      idField: 'id',
      textField: 'name',
      singleSelection: true,
      selectAllText: 'Selecionar tudo',
      searchPlaceholderText: 'Localizar',
      unSelectAllText: 'Deselecionar Tudo',
      allowSearchFilter: true,
      noDataAvailablePlaceholderText: 'Nenhum registro encontrado',
    };
    this.getSearch();
    this.get(this.parentId);
  }

  getSearch() {
    this.internalSearchService.findIsMedia().toPromise().then(result => {
      this.searchs = result.body;
    });
  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      name: ['', Validators.required]
    });
  }

  onSubmit() {
    this.submitted = true;

    if (this.registerForm.invalid) {
      return;
    }

    this.save();
  }

  setEntitySelected(name) {
    this.entitySelected = [];
    for (let i = 0; i < this.entities.length; i++) {
      const entity = this.entities[i];
      if (entity.code === name) {
        this.entitySelected.push(entity);
      }
    }
  }

  setSearchSelected(id) {
    this.searchSelected = [];
    for (let i = 0; i < this.searchs.length; i++) {
      const searchSel = this.searchs[i];
      if (searchSel.id === id) {
        this.searchSelected.push(searchSel);;
      }
    }
  }

  setPeriodoSelected(name) {
    this.periodoSelected = [];
    for (let i = 0; i < this.periodos.length; i++) {
      const periodo = this.periodos[i];
      if (periodo.code === name) {
        this.periodoSelected.push(periodo);
      }
    }
  }

  get(parentId) {
    if (parentId === 'create') {
      this.ehsMicroIndicador = {};
      this.entitySelected = { name: 'Feedback', code: 'FEEDBACK' };
    } else {
      this.ehsService.find(this.parentId).toPromise().then(response => {
        this.ehsMicroIndicador = response.body;
        this.setEntitySelected(this.ehsMicroIndicador.entity);
        this.setPeriodoSelected(this.ehsMicroIndicador.periodo);

        if (this.ehsMicroIndicador.internalSearch) {
          this.setSearchSelected(this.ehsMicroIndicador.internalSearch.id);
          this.ehsMicroIndicador.internalSearchId = this.ehsMicroIndicador.internalSearch.id;
          delete this.ehsMicroIndicador.internalSearch;
        }


      });
    }
  }

  goBack() {
    this.router.navigate(['pages/admin/ehs-micro-indicador']);
  }

  valid() {

    if (!this.ehsMicroIndicador) {
      this.showMessageValid('Preencha todos os campos');
      return false;
    } else {
      if (!this.ehsMicroIndicador.name) {
        this.showMessageValid('Preecha o campo nome');
        return false;
      }
      if (!this.ehsMicroIndicador.entity) {
        this.showMessageValid('Selecione uma origem');
        return false;
      } else {
        if (this.ehsMicroIndicador.entity === 'FEEDBACK') {
          if (!this.ehsMicroIndicador.weightSingle) {
            this.showMessageValid('Preencha o campo peso unitário');
            return false;
          }
          if (!this.ehsMicroIndicador.weightMax) {
            this.showMessageValid('Preencha o campo peso máximo');
            return false;
          }
          if (this.ehsMicroIndicador.weightSingle > this.ehsMicroIndicador.weightMax) {
            this.showMessageValid('O campo peso unitário não pode ser maior que o peso máximo');
            return false;
          }
          if (!this.ehsMicroIndicador.periodo) {
            this.showMessageValid('Selecione um periodo');
            return false;
          }
        }
        if (this.ehsMicroIndicador.entity === 'INTERNAL_SEARCH') {
          if (!this.ehsMicroIndicador.weightSingle) {
            this.showMessageValid('Preencha o campo peso unitário');
            return false;
          }
          if (!this.ehsMicroIndicador.weightMax) {
            this.showMessageValid('Preencha o campo peso máximo');
            return false;
          }
          if (this.ehsMicroIndicador.weightSingle > this.ehsMicroIndicador.weightMax) {
            this.showMessageValid('O campo peso unitário não pode ser maior que o peso máximo');
            return false;
          }
          if (!this.ehsMicroIndicador.internalSearchId) {
            this.showMessageValid('Selecione uma pesquisa');
            return false;
          }
        }
        if (this.ehsMicroIndicador.entity === 'EXTERNAL') {
          if (!this.ehsMicroIndicador.weightMax) {
            this.showMessageValid('Preencha o campo peso máximo');
            return false;
          }
        }
      }
    }

    return true;
  }

  showMessageValid(message) {
    this.toastrService.show('microindicador', message,
      { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'danger' });
  }

  save() {
    if (this.entitySelected) {
      if (this.entitySelected[0]) {
        this.ehsMicroIndicador.entity = this.entitySelected[0].code;
      }
    }
    if (this.periodoSelected) {
      if (this.periodoSelected[0]) {
        this.ehsMicroIndicador.periodo = this.periodoSelected[0].code;
      }
    }

    if (this.searchSelected) {
      if (this.searchSelected[0]) {
        this.ehsMicroIndicador.internalSearchId = this.searchSelected[0].id;
      }
    }

    if (!this.valid()) {
      return;
    }
    if (this.ehsMicroIndicador.id) {
      this.ehsService.update(this.ehsMicroIndicador).toPromise().then(response => {
        this.toastrService.show('EHS', 'Salvo com sucesso',
          { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
        this.goBack();
      });
    } else {
      this.ehsService.create(this.ehsMicroIndicador).toPromise().then(response => {
        this.toastrService.show('EHS', 'Salvo com sucesso',
          { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
        this.goBack();
      });
    }
  }

}
